// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes rotating {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
:host {
  display: flex;
  overflow: hidden;
}
:host .theme-options-panel {
  display: flex;
  flex-direction: column;
  flex: 1 0 auto;
  padding: 40px 24px 24px 24px;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}
:host .theme-options-panel .header {
  display: flex;
  flex: 0 1 auto;
  margin-bottom: 32px;
  align-items: center;
  justify-content: space-between;
}
:host .theme-options-panel .header .title {
  font-size: 20px;
  font-weight: 500;
  padding-left: 4px;
}
:host .theme-options-panel form {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
}
:host .theme-options-panel form .group {
  display: flex;
  flex: 1 0 auto;
  flex-direction: column;
  position: relative;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 2px;
  padding: 28px 16px 8px 16px;
  margin: 16px 0;
}
:host .theme-options-panel form .group h2 {
  position: absolute;
  top: -11px;
  left: 8px;
  margin: 0;
  padding: 0 8px;
  font-size: 16px;
  font-weight: 500;
  background: white;
  color: rgba(0, 0, 0, 0.54);
}
:host .theme-options-panel form .group h3 {
  font-size: 14px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.54);
  margin: 24px 0 16px 0;
  padding: 0;
}
:host .theme-options-panel form .group h3:first-of-type {
  margin-top: 0;
}`, "",{"version":3,"sources":["webpack://./src/@fuse/components/theme-options/theme-options.component.scss"],"names":[],"mappings":"AAEA;EACI;IACI,uBAAA;EADN;EAGE;IACI,yBAAA;EADN;AACF;AAIA;EACI,aAAA;EACA,gBAAA;AAFJ;AAII;EACI,aAAA;EACA,sBAAA;EACA,cAAA;EACA,4BAAA;EACA,cAAA;EACA,iCAAA;AAFR;AAIQ;EACI,aAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;AAFZ;AAIY;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;AAFhB;AAMQ;EACI,aAAA;EACA,cAAA;EACA,sBAAA;AAJZ;AAMY;EACI,aAAA;EACA,cAAA;EACA,sBAAA;EACA,kBAAA;EACA,qCAAA;EACA,kBAAA;EACA,2BAAA;EACA,cAAA;AAJhB;AAMgB;EACI,kBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,0BAAA;AAJpB;AAOgB;EACI,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,qBAAA;EACA,UAAA;AALpB;AAOoB;EACI,aAAA;AALxB","sourcesContent":["@import \"@fuse/scss/fuse\";\r\n\r\n@keyframes rotating {\r\n    from {\r\n        transform: rotate(0deg);\r\n    }\r\n    to {\r\n        transform: rotate(360deg);\r\n    }\r\n}\r\n\r\n:host {\r\n    display: flex;\r\n    overflow: hidden;\r\n\r\n    .theme-options-panel {\r\n        display: flex;\r\n        flex-direction: column;\r\n        flex: 1 0 auto;\r\n        padding: 40px 24px 24px 24px;\r\n        overflow: auto;\r\n        -webkit-overflow-scrolling: touch;\r\n\r\n        .header {\r\n            display: flex;\r\n            flex: 0 1 auto;\r\n            margin-bottom: 32px;\r\n            align-items: center;\r\n            justify-content: space-between;\r\n\r\n            .title {\r\n                font-size: 20px;\r\n                font-weight: 500;\r\n                padding-left: 4px;\r\n            }\r\n        }\r\n\r\n        form {\r\n            display: flex;\r\n            flex: 1 1 auto;\r\n            flex-direction: column;\r\n\r\n            .group {\r\n                display: flex;\r\n                flex: 1 0 auto;\r\n                flex-direction: column;\r\n                position: relative;\r\n                border: 1px solid rgba(0, 0, 0, 0.12);\r\n                border-radius: 2px;\r\n                padding: 28px 16px 8px 16px;\r\n                margin: 16px 0;\r\n\r\n                h2 {\r\n                    position: absolute;\r\n                    top: -11px;\r\n                    left: 8px;\r\n                    margin: 0;\r\n                    padding: 0 8px;\r\n                    font-size: 16px;\r\n                    font-weight: 500;\r\n                    background: white;\r\n                    color: rgba(0, 0, 0, 0.54);\r\n                }\r\n\r\n                h3 {\r\n                    font-size: 14px;\r\n                    font-weight: 500;\r\n                    color: rgba(0, 0, 0, 0.54);\r\n                    margin: 24px 0 16px 0;\r\n                    padding: 0;\r\n\r\n                    &:first-of-type {\r\n                        margin-top: 0;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
